import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TrackingView } from '../../models';
import { DEFAULT_VISIBLE_TRACKING_VIEW_LENGTH } from '../../constants';
import { OrderHistoryApplicationEvent } from '~shared/modules/application-event/models';
import { GaTrackingEventCategory, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { OrderHistoryEventActionType } from '~shared/modules/application-event/constants';

@Component({
  selector: 'app-tracking-number-list',
  templateUrl: './tracking-number-list.component.html',
  styleUrls: ['./tracking-number-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingNumberListComponent {
  public toggleLength = DEFAULT_VISIBLE_TRACKING_VIEW_LENGTH;
  public visibleTrackingsLength = this.toggleLength;
  public shouldShowFullList = false;

  @Input() trackings: TrackingView[];

  constructor(private applicationEventService: ApplicationEventService) {
  }

  public toggleTrackingLength(): void {
    this.shouldShowFullList = !this.shouldShowFullList;
    if (this.shouldShowFullList) {
      this.visibleTrackingsLength = this.trackings.length;
    } else {
      this.visibleTrackingsLength = this.toggleLength;
    }
  }

  public navigateToDeliveryCarrierClicked(url: string | null | undefined) {
    if (url) {
      this.applicationEventService.publish(new OrderHistoryApplicationEvent({
        event: GaTrackingEventName.NavigateToDeliveryCarrier,
        action: OrderHistoryEventActionType.NavigateToDeliveryCarrier,
        label: url,
        category: GaTrackingEventCategory.Navigation,
      }));
    }
  }

}
